import { FC, SVGProps } from 'react'

export const AccessIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="27.5" cy="27.5" r="27.5" fill="#00B38D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.0469 16.5001C42.1158 17.312 42.3157 18.8257 41.4935 19.8812L26.6002 39L16.7151 29.2388C15.7616 28.2972 15.7616 26.7707 16.7151 25.8291C17.6686 24.8875 19.2146 24.8875 20.1681 25.8291L26.1205 31.707L37.623 16.9411C38.4452 15.8857 39.9781 15.6882 41.0469 16.5001Z"
        fill="white"
      />
    </svg>
  )
}
